// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3696":"fd79bb08","7081":"6bd6fd57"}[chunkId] + ".chunk.css";
};